"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9012],{

/***/ 59012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_Favorite__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(36111);
/* harmony import */ var _mui_icons_material_FavoriteBorder__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(91811);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(99226);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(69661);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69368);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var _assets_Icons_CalendarIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64557);
/* harmony import */ var _constants_ProposalState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8573);
/* harmony import */ var _constants_UserType__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22898);
/* harmony import */ var _firebase_gig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30622);
/* harmony import */ var _firebase_user__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32012);
/* harmony import */ var _helper_dates__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18621);
/* harmony import */ var _helper_gigStates__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50481);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24849);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40570);
/* harmony import */ var _gigs_DataChip__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1582);
/* harmony import */ var _gigs_GigTimingsTitle__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48390);
/* harmony import */ var _GigStateTag__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99020);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97734);






















var GigCard = function(param) {
    var gig = param.gig, _gigStatusDisplay = param.gigStatusDisplay, gigStatusDisplay = _gigStatusDisplay === void 0 ? false : _gigStatusDisplay, gigState = param.gigState;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var gigStateValue = gig && (gigState ? gigState : gig.gigState);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), favourite = ref6[0], setFavourite = ref6[1];
    var ref7 = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.user.user;
    }), userUid = ref7.uid;
    var userType = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.user.user.userType;
    });
    var handleClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
            var proposalData;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!userUid) return [
                            3,
                            4
                        ];
                        if (!(userType === _constants_UserType__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Chef */ .Z.Chef && gig.gigId)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,_firebase_gig__WEBPACK_IMPORTED_MODULE_7__/* .fetchGigProposal */ .oP)(userUid, gig.gigId)
                        ];
                    case 1:
                        proposalData = _state.sent();
                        if (!proposalData.proposalState) {
                            router.push("/gig/".concat(gig.gigId, "/proposal/").concat(userUid));
                        }
                        if (!proposalData.proposalState || proposalData.proposalState === _constants_ProposalState__WEBPACK_IMPORTED_MODULE_5__/* ["default"].DRAFT */ .Z.DRAFT) {
                            router.push("/gig/".concat(gig.gigId, "/proposal/").concat(userUid));
                        } else {
                            router.push("/gigs/".concat(userUid, "/proposal-preview/").concat(gig.gigId));
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        if (gig.ownerUid === userUid) {
                            router.push("/gigs/".concat(userUid, "/all-proposal/").concat(gig.gigId));
                        } else {
                            router.push("/gig/".concat(gig.gigId, "/proposal/").concat(userUid));
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        router.push("/gig/".concat(gig.gigId));
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), gigOwnerProfileImage = ref8[0], setGigOwnerProfileImage = ref8[1];
    var setUserProfileImage = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
            var profileImage;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!gig.ownerUid) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,_firebase_user__WEBPACK_IMPORTED_MODULE_8__/* .fetchUserProfileImage */ .Es)(gig.ownerUid)
                        ];
                    case 1:
                        profileImage = _state.sent();
                        profileImage && setGigOwnerProfileImage(profileImage);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function setUserProfileImage() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isLiked = false;
        if (gig.likedBy && userUid && gig.likedBy.indexOf(userUid) > -1) {
            isLiked = true;
        }
        setFavourite(isLiked);
        setUserProfileImage();
    }, []);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var handleLikeDislike = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(e) {
            var favouriteData;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.stopPropagation();
                        favouriteData = !favourite;
                        setFavourite(favouriteData);
                        if (!userUid) {
                            return [
                                2,
                                router.push("/auth/login")
                            ];
                        }
                        if (!gig.gigId) return [
                            3,
                            4
                        ];
                        if (!(favouriteData === true)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,_firebase_user__WEBPACK_IMPORTED_MODULE_8__/* .addFavouriteGig */ .Qe)(userUid, gig.gigId)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            (0,_firebase_user__WEBPACK_IMPORTED_MODULE_8__/* .removeFavouriteGig */ .lC)(userUid, gig.gigId)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLikeDislike(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var startDate = (0,_helper_dates__WEBPACK_IMPORTED_MODULE_9__/* .getGigStartDate */ .Yw)(gig);
    var endDate = (0,_helper_dates__WEBPACK_IMPORTED_MODULE_9__/* .getGigEndDate */ .q1)(gig);
    var titleList = [
        {
            title: "Gig Created",
            date: (gig === null || gig === void 0 ? void 0 : gig.createdAt) ? (0,_helper_dates__WEBPACK_IMPORTED_MODULE_9__/* .convertDateFormat */ .fc)(gig === null || gig === void 0 ? void 0 : gig.createdAt) : " N/A"
        },
        {
            title: "Gig Start Date",
            date: startDate ? (0,_helper_dates__WEBPACK_IMPORTED_MODULE_9__/* .convertDateFormat */ .fc)(startDate) : "N/A"
        },
        {
            title: "Gig End Date",
            date: endDate ? (0,_helper_dates__WEBPACK_IMPORTED_MODULE_9__/* .convertDateFormat */ .fc)(endDate) : "N/A"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
        py: {
            xs: 1
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
            onClick: handleClick,
            sx: {
                p: {
                    xs: 3,
                    md: 4
                },
                cursor: "pointer",
                borderLeft: "4px solid ".concat((0,_helper_gigStates__WEBPACK_IMPORTED_MODULE_10__/* .getStateData */ .O)(gigStateValue).color)
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    sx: {
                        background: "".concat(gig && gig.headerImageUrl ? 'url("'.concat(gig.headerImageUrl, '")') : _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.grey2[100] */ .r.grey2[100]),
                        height: {
                            xs: "4rem",
                            md: "9.8rem"
                        },
                        width: "100%",
                        display: "flex",
                        alignItems: {
                            xs: "start",
                            md: "end"
                        },
                        justifyContent: "space-between",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        borderRadius: "0.375rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            sx: {
                                padding: 2
                            },
                            children: gigStateValue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GigStateTag__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                gigStateValue: gigStateValue
                            })
                        }),
                        (gig === null || gig === void 0 ? void 0 : gig.isPrivate) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            sx: {
                                alignSelf: "flex-start",
                                backgroundColor: "rgba(25, 17, 34, 0.75)",
                                color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.whiteBg.WBG1 */ .r.whiteBg.WBG1,
                                borderBottomLeftRadius: "8px",
                                px: 1.5,
                                py: 0.5,
                                fontSize: {
                                    xs: "0.65rem",
                                    md: "0.75rem"
                                },
                                fontWeight: 600,
                                textTransform: "uppercase",
                                letterSpacing: "0.08em"
                            },
                            children: "Private gig"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                    container: true,
                    sx: {
                        py: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "left"
                            },
                            item: true,
                            xs: 10,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    sx: {
                                        width: {
                                            md: "1.5rem"
                                        },
                                        height: {
                                            md: "1.5rem"
                                        },
                                        cursor: "pointer"
                                    },
                                    alt: "Profile image",
                                    // onClick={handleAvatarClick}
                                    src: gigOwnerProfileImage
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    variant: "title5",
                                    sx: {
                                        color: "".concat(_mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.black[800] */ .r.black[800], " !important"),
                                        marginLeft: "1em"
                                    },
                                    children: gig && gig.title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                            item: true,
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "right"
                            },
                            xs: 2,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                sx: {
                                    ml: "auto"
                                },
                                checked: favourite,
                                onChange: handleLikeDislike,
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_FavoriteBorder__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {}),
                                checkedIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Favorite__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                    sx: {
                                        color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.brand2[300] */ .r.brand2[300]
                                    }
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    sx: {
                        display: "flex"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            sx: {
                                flexGrow: "1"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                                sx: {
                                    mb: "1rem",
                                    display: "flex",
                                    alignItems: "flex-end",
                                    width: "100%"
                                },
                                container: true,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gigs_DataChip__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "Type of Service",
                                        data: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                variant: "small5",
                                                sx: {
                                                    color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.brand1[500] */ .r.brand1[500],
                                                    maxWidth: {
                                                        xs: "100px",
                                                        md: "130px"
                                                    },
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                },
                                                children: gig && gig.serviceType
                                            }, gig && gig.serviceType), 
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gigs_DataChip__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "Location",
                                        data: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                variant: "small5",
                                                sx: {
                                                    color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.brand1[500] */ .r.brand1[500],
                                                    maxWidth: {
                                                        xs: "60px",
                                                        md: "80px"
                                                    },
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                },
                                                children: (gig === null || gig === void 0 ? void 0 : (ref = gig.location) === null || ref === void 0 ? void 0 : ref.locality) && (gig === null || gig === void 0 ? void 0 : (ref1 = gig.location) === null || ref1 === void 0 ? void 0 : ref1.state) && "".concat((ref2 = gig.location) === null || ref2 === void 0 ? void 0 : ref2.locality, ", ").concat((ref3 = gig.location) === null || ref3 === void 0 ? void 0 : ref3.state)
                                            }, gig && "".concat((ref4 = gig.location) === null || ref4 === void 0 ? void 0 : ref4.locality, ", ").concat((ref5 = gig.location) === null || ref5 === void 0 ? void 0 : ref5.state)), 
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gigs_DataChip__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "Guests",
                                        data: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: gig && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                    variant: "small4",
                                                    sx: {
                                                        color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.brand1[500] */ .r.brand1[500],
                                                        maxWidth: {
                                                            xs: "40px",
                                                            md: "60px"
                                                        }
                                                    },
                                                    children: gig.numberOfGuests
                                                }, gig && "".concat(gig.numberOfGuests))
                                            }), 
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gigs_DataChip__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "Budget",
                                        data: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                variant: "small4",
                                                sx: {
                                                    color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_11__/* .theme.brand1[500] */ .r.brand1[500],
                                                    maxWidth: {
                                                        xs: "40px",
                                                        md: "60px"
                                                    }
                                                },
                                                children: "$".concat(gig === null || gig === void 0 ? void 0 : gig.budget)
                                            }, gig === null || gig === void 0 ? void 0 : gig.budget), 
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            sx: {
                                display: {
                                    xs: "none",
                                    md: "block"
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                sx: {
                                    width: {
                                        md: "200px"
                                    }
                                },
                                onClick: handleClick,
                                children: "View Details"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                    container: true,
                    sx: {
                        my: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 1,
                            sx: {
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "center",
                                mr: "1rem",
                                flexDirection: "column"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_Icons_CalendarIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    sx: {
                                        display: {
                                            lg: "none"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_Icons_CalendarIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                            container: true,
                            item: true,
                            xs: 10,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 12,
                                sx: {
                                    my: "1rem"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gigs_GigTimingsTitle__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    titleList: titleList
                                })
                            })
                        })
                    ]
                }),
                gigStateValue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    sx: {
                        display: {
                            xs: "flex",
                            md: "none"
                        },
                        justifyContent: "center",
                        "& button": {
                            width: "100% !important"
                        }
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        sx: {
                            width: {
                                md: "200px"
                            }
                        },
                        onClick: handleClick,
                        children: "View Details"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GigCard);


/***/ })

}]);